// extracted by mini-css-extract-plugin
export var addButton = "_bu-0";
export var border = "_bu-8";
export var check = "_bu-h";
export var danger = "_bu-6";
export var dropdownContainer = "_bu-1";
export var editModalBody = "_bu-j";
export var footerContainer = "_bu-i";
export var fullWidth = "_bu-a";
export var hide = "_bu-9";
export var icon = "_bu-3";
export var input = "_bu-7";
export var inputFlex = "_bu-b";
export var inputWrapper = "_bu-c";
export var manualFocus = "_bu-5";
export var optionButton = "_bu-4";
export var pillWrapper = "_bu-e";
export var pointer = "_bu-2";
export var showOverflow = "_bu-f";
export var tagsFlex = "_bu-d";
export var xButton = "_bu-g";